import { Box, Heading, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import React from "react";
import { useHistory } from "react-router";
import AddQuoteMenu, { AddQuoteMenuActions } from "./AddQuoteMenu";

const EmptyTableInnerFlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export interface EmptyQuotesTableProps {
  label?: string;
  showAddQuoteMenu?: boolean;
}

function EmptyQuotesTable(props: EmptyQuotesTableProps) {
  const {
    label = "Get started by creating a new quote",
    showAddQuoteMenu = true,
  } = props;

  const history = useHistory();

  const addQuoteHandler = (action: AddQuoteMenuActions) => {
    history.push(`/quotes/new?type=${action.toLowerCase()}`);
  };

  return (
    <Box
      minHeight="xl"
      display="flex"
      borderStyle="dashed"
      borderWidth="medium"
    >
      <EmptyTableInnerFlexContainer>
        <Heading fontWeight="medium" size="md" as="h4">
          No Quotes
        </Heading>
        <Text marginTop={2}>{label}</Text>
        <Box marginTop={6}>
          {showAddQuoteMenu && (
            <AddQuoteMenu menuItemClickHandler={addQuoteHandler} />
          )}
        </Box>
      </EmptyTableInnerFlexContainer>
    </Box>
  );
}

export default EmptyQuotesTable;
